import '../scss/styles.scss';
//JS

const slick = require('slick-slider');
const fancybox = require('@fancyapps/fancybox');

import "jquery-match-height/jquery.matchHeight"
import "@fancyapps/fancybox"
import "./sliders"
import "./modal"
import "./accordion"
import "./app"
import "./hireform"
import "./global"
import "./filters"
import "./productTabs"
import "./cart"

import "./megaMenu"

//submit tickets
import "./submitTicket"
import "./leaveComment"

//Forms
import "./updateInfo"

//Account functionality & modals
import "./activeCourses"
import "./activeCoursesAttendee"
import "./orderHistory"
import "./supportTickets"
import "./activeCourses"
import "./orderHistory"
import "./supportTickets"
import "./studentDiscussions"
import "./allStudents"
import "./generateInvoice"

//Checkout
import "./checkout"